/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UpgradeInputs */

const en_upgrade = /** @type {(inputs: UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade`)
};

const es_upgrade = /** @type {(inputs: UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar`)
};

const fr_upgrade = /** @type {(inputs: UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à niveau`)
};

const de_upgrade = /** @type {(inputs: UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade`)
};

const ja_upgrade = /** @type {(inputs: UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップグレード`)
};

const zh_upgrade = /** @type {(inputs: UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`升级`)
};

const ar_upgrade = /** @type {(inputs: UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ترقية`)
};

const id_upgrade = /** @type {(inputs: UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingkatkan`)
};

const it_upgrade = /** @type {(inputs: UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna`)
};

const ru_upgrade = /** @type {(inputs: UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Улучшить тариф`)
};

const pt_upgrade = /** @type {(inputs: UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer Upgrade`)
};

const ko_upgrade = /** @type {(inputs: UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`업그레이드`)
};

/**
* | output |
* | --- |
* | "Upgrade" |
*
* @param {UpgradeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upgrade = /** @type {((inputs?: UpgradeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UpgradeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgrade(inputs)
	if (locale === "es") return es_upgrade(inputs)
	if (locale === "fr") return fr_upgrade(inputs)
	if (locale === "de") return de_upgrade(inputs)
	if (locale === "ja") return ja_upgrade(inputs)
	if (locale === "zh") return zh_upgrade(inputs)
	if (locale === "ar") return ar_upgrade(inputs)
	if (locale === "id") return id_upgrade(inputs)
	if (locale === "it") return it_upgrade(inputs)
	if (locale === "ru") return ru_upgrade(inputs)
	if (locale === "pt") return pt_upgrade(inputs)
	return ko_upgrade(inputs)
});